// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDatabase } from '@ni/nimble-components/dist/esm/icons/database';
import { wrap } from '../utilities/react-wrapper';

export { type IconDatabase };
export const NimbleIconDatabase = wrap(IconDatabase);